import React from 'react';
import PropTypes from 'prop-types';
import withData from 'util/hoc/with-data';
import HiringQuery from 'apps/hiring/util/query';
import { resolve } from 'library/helpers/path-resolver';
import Toggle from 'library/components/form-elements/toggle';
import { jsonToInputParams } from 'library/util/graph';
import 'apps/admin/styles/components/groups-manager.scss';

class OpeningToggle extends React.Component {
  handleToggle = async () => {
    this.setState({ loading: true });
    const {
      graph_data
    } = this.props;

    const params = {
      id: this.props.id,
      archived: !resolve(graph_data, 'opening/closed', true),
      settings: {
        closed: !resolve(graph_data, 'opening/closed', true)
      }
    };

    const { data } = await HiringQuery(`
      mutation {
        update_opening (${jsonToInputParams(params)}) {
          success
        }
      }
    `);

    if (resolve(data, 'update_opening/success', false)) {
      this.props.reload_graph(true);
    }
    this.setState({ loading: false });
  }

  render() {
    const {
      graph_data,
      graph_loading
    } = this.props;

    if (graph_loading) return 'Loading';

    return (
      <div className="admin-opening-toggle">
        <h1> OPENING IS {resolve(graph_data, 'opening/closed', true) ? 'CLOSED' : 'OPEN'} </h1>
        <Toggle
          className="admin-toggle"
          checked={!resolve(graph_data, 'opening/closed', true)}
          onChange={() => this.handleToggle()}
        />
      </div>
    );
  }
}

OpeningToggle.propTypes = {
  id: PropTypes.number,
  graph_data: PropTypes.object,
  graph_loading: PropTypes.bool,
  reload_graph: PropTypes.func
};

OpeningToggle.query = (token, props) => (
  HiringQuery( `
    {
      opening(id:${resolve(props, 'id', null)}) {
        archived,
        closed
      }
    }
  `)
);

export default withData(OpeningToggle);
